import * as PIXI from "pixi.js";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import UIFacade from "../UIFacade";
import DynamicTextComponent from "@baseUI/component/text/DynamicTextComponent";
import SimpleTextComponent from "@baseUI/component/text/SimpleTextComponent";
import ConfigDynamicTextStylesBase from "@baseUI/config/ConfigDynamicTextStylesBase";

export default new class UICreatorText {
    constructor () {}

    addElementTextStyle = (name, container, position) =>{
        const mc = new UIFacade.textFactory.getTextWithStyle(name)
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementText = (name, style, container, position) => {
        const text = UIFacade.textFactory.getLocalizedText(name)
        let mc = new LocalizedPIXIText(text, UIFacade.textFactory.getStyle(style))
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementTextSimple = (text, style, container, position, anchor = 0.5) => {
        let mc = new LocalizedPIXIText(text, UIFacade.textFactory.getStyle(style))
        mc.anchor.set(anchor)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementTextName = (name, container, position, anchor =  0.5) => {
        const mc = new UIFacade.textFactory.getTextWithStyle(name)
        mc.anchor.set(anchor)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
        // const text = Facade.textFactory.getLocalizedText(name)
        // return this.addElementText(text, style, container, position)
    }

    addElementBitmapText = (text, style, container, position, filters) => {
        let mc = new PIXI.BitmapText(text, style)
        mc.anchor.set(0.5)
        container.addChild(mc)
        if (filters){
            mc.filters = filters
        }
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementDynamicTextName2 = (name, container, position, anchor =  0.5) => {
        const mc = new DynamicTextComponent(name)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementDynamicTextName = (name, container, position) => {
        const style = ConfigDynamicTextStylesBase.dynamicText[name].styleName
        const mc = new SimpleTextComponent(UIFacade.textFactory.getStyle(style))
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementDynamicStyleTextName = (name, style, container, position) => {
        const mc = new SimpleTextComponent(UIFacade.textFactory.getStyle(style))
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addSimpleTextComponent = (name, style, container, position) => {
        const text = UIFacade.textFactory.getLocalizedText(name)
        let stc = new SimpleTextComponent(UIFacade.textFactory.getStyle(style))
        stc.text = text
        container.addChild(stc)
        if (position) {
            stc.position.set(...position)
        }
        return stc
    }

}()
